export const NODATA_TEXT = 'Get started by creating a new transaction'
export const SEARCH_TEXT = 'Search transactions...'

export const TRANSACTIONS_FILTER_KEY = ['transactions', 'list', 'filter']
export const TRANSACTIONS_SEARCH_KEY = ['transactions', 'list', 'search']
export const TRANSACTIONS_SORT_KEY = ['transactions', 'list', 'sort']
export const TRANSACTIONS_VIEW_KEY = ['transactions', 'list', 'view']
export const TRANSACTIONS_PAGE_SIZE_KEY = ['transactions', 'list', 'pageSize']
export const IMPORT_DIALOG_TITLE = 'Import transactions'

export const IMPORT_HEADERS_KEYS = 'type,date,account1,amount1,asset1,account2,amount2,asset2,account3,amount3,asset3,account4,amount4,asset4,description'
export const IMPORT_HEADERS_EXAMPLE = 'Transaction Type,Date,Account 1,Amount 1,Asset 1,Account 2,Amount 2,Asset 2,Account 3,Amount 3,Asset 3,Account 4,Amount 4,Asset 4,Description'

// Legacy headers for backward compatibility (can be extended with additional formats)
export const IMPORT_LEGACY_HEADERS = [
  'type,date,account1,amount1,asset1,account2,amount2,asset2,account3,account4,description',
]
